import React from 'react';
import { Stack, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const FormSentInfo = () => (
  <Stack direction="column" justifyContent="center" alignItems="center" spacing={2}>
    <CheckCircleOutlineIcon color="success" sx={{ fontSize: '48px' }} />
    <Typography variant="h3">Formularz został pomyślnie wysłany</Typography>
  </Stack>
);

export default FormSentInfo;
